import * as yup from 'yup'

export const societyDiscountCodeSchema = yup
  .object({
    discountCode: yup.string().required(),
  })
  .required()
